
import Vue from 'vue'

// Interfaces for component typechecking!
interface AppData {

}

interface AppMethods {
	showMore(): void;
}

interface AppComputed {
	total: string
	amount: string
}

interface AppProps {

}

export default Vue.extend<AppData, AppMethods, AppComputed, AppProps>({
	name: 'Pagination',
	computed: {
		total() {
			return this.$store.getters.total
		},
		amount() {
			return this.$store.getters.amount
		}
	},
	methods: {
		showMore() {
			this.$store.dispatch({
				type: 'search',
				payload: false
			})
		}
	},
})
